import { render } from "./IconVisitor.vue?vue&type=template&id=7094253f"
import script from "./IconVisitor.vue?vue&type=script&lang=js"
export * from "./IconVisitor.vue?vue&type=script&lang=js"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__